import type { Explanation } from '../api/types';
import { asList, paragraphs } from '../lib/format';

export function Prose({ text, className }: { text: string | null | undefined; className?: string }) {
  const parts = paragraphs(text);
  if (parts.length === 0) return null;
  return (
    <div className={className === undefined ? 'prose' : `prose ${className}`}>
      {parts.map((part) => (
        <p key={part}>{part}</p>
      ))}
    </div>
  );
}

/** Renders a paragraph-or-list explanation, stating plainly when nothing was recorded. */
export function ExplanationBlock({ value, empty }: { value: Explanation | null | undefined; empty: string }) {
  const items = asList(value);
  if (items.length === 0) return <p className="muted">{empty}</p>;
  if (items.length === 1) return <Prose text={items[0]} />;
  return (
    <ul className="point-list">
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
}
